import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Row as StickyRow } from 'react-sticky-table';
import selectn from 'selectn';
// component
import { Text } from 'Component/Ajaib';
import { TableColumn } from 'Component/Table';
import { FormatPercentage } from 'Component/NumberFormat';

// style
import useEventTracker from './tracker';
import styles from './style';

const DashboardMutualFundContent = (props) => {
  const navigate = useNavigate();
  const { categoryId, returnConfig } = props;
  const data = useSelector((state) => state.mutualFund.mutualFundData);
  const results = selectn(`${categoryId}.results`, data) || [];
  const { eventClickMfDetail } = useEventTracker();

  return results.map((result) => {
    const returnVariable = `historical_return_object.${returnConfig || '1Y'}`;
    let historicalReturn = selectn(returnVariable, result);
    if (!historicalReturn) {
      historicalReturn = selectn('historical_return_object.All', result) || 0;
    }
    historicalReturn *= 100;
    return (
      <StickyRow
        key={`${categoryId}-${result.id}`}
        style={styles.dataRow}
        onClick={() => {
          navigate(`/home/reksadana/${result.id}`);
          const eventProps = {
            tab: 'allocation',
            'fund name': result.fund_name,
            'fund id': result.id,
            'fund manager': result.manager_short_name ?? '',
            'entry point': 'home',
          };
          eventClickMfDetail(eventProps);
        }}
      >
        <TableColumn as="sticky">
          <Text>{result.fund_name}</Text>
        </TableColumn>
        <TableColumn as="sticky" isNumber>
          <Text bold positive={historicalReturn > 0} negative={historicalReturn < 0}>
            <FormatPercentage value={historicalReturn} />
          </Text>
        </TableColumn>
      </StickyRow>
    );
  });
};

export default DashboardMutualFundContent;
